import {
  IS_CHROME_EXTENSION,
  OKTA_CLIENT_ID,
  OKTA_DISCOVERY_URL,
  OKTA_SCOPES,
  SERVICE_URL,
} from "@src/env";

const ISSUER = `${OKTA_DISCOVERY_URL}`;

// For Chrome extension, use Chrome's identity redirect URL
// For web app, use the standard callback URL
function getRedirectUri(): string {
  if (IS_CHROME_EXTENSION && typeof chrome !== "undefined" && chrome.identity) {
    return chrome.identity.getRedirectURL();
  }
  return `${SERVICE_URL}/login/callback`;
}

const REDIRECT_URI = getRedirectUri();

export const config = {
  clientId: OKTA_CLIENT_ID,
  issuer: ISSUER,
  redirectUri: REDIRECT_URI,
  scopes: OKTA_SCOPES,
};
